import{
    CREATE_CLAIMFORM_START,
    CREATE_CLAIMFORM_SUCCESS,
    CREATE_CLAIMFORM_FAILURE,
    CREATE_CLAIMFORM_RESET,
    UPDATE_CLAIMFORM_START,
    UPDATE_CLAIMFORM_SUCCESS,
    UPDATE_CLAIMFORM_FAILURE,
    UPDATE_CLAIMFORM_RESET,
    GET_CLAIMFORM_START,
    GET_CLAIMFORM_SUCCESS,
    GET_CLAIMFORM_FAILURE,
    GET_CLAIMFORM_RESET,
    SORT_CLAIMFORM_START,
    SORT_CLAIMFORM_SUCCESS,
    SORT_CLAIMFORM_FAILURE,
    SORT_CLAIMFORM_RESET,
    VIEW_CLAIMFORM_START,
    VIEW_CLAIMFORM_SUCCESS,
    VIEW_CLAIMFORM_FAILURE,
    VIEW_CLAIMFORM_RESET,
    CREATE_CLAIM_LINK,
    CREATE_CLAIM_LINK_SUCCESS,
    CREATE_CLAIM_LINK_FAILED,
    VIEW_CLAIM_LINK,
    VIEW_CLAIM_LINK_SUCCESS,
    VIEW_CLAIM_LINK_FAILED,
    SUBMIT_CLAIM_LINK,
    SUBMIT_CLAIM_LINK_SUCCESS,
    SUBMIT_CLAIM_LINK_FAILED,
    CUSTOMER_POLICY_CLAIM,
    CUSTOMER_POLICY_CLAIM_SUCCESS,
    CUSTOMER_POLICY_CLAIM_FAILED,
    CUSTOMER_POLICY_LOB,
    CUSTOMER_POLICY_LOB_SUCCESS,
    CUSTOMER_POLICY_LOB_FAILED
} from "./actiontypes"


export const createClaimFormStart = payload => {
    return {
      type: CREATE_CLAIMFORM_START,
      payload,
    }
  }
  
  export const createClaimFormSuccess = payload => {
    return {
      type: CREATE_CLAIMFORM_SUCCESS,
      payload,
    }
  }

  export const createClaimFormFailure = error => {
    return {
      type: CREATE_CLAIMFORM_FAILURE,
      error,
    }
  }
  export const createClaimFormReset = () => {
    return {
      type: CREATE_CLAIMFORM_RESET,
    }
  }


  
export const getClaimFormStart =()  => {
  return {
    type: GET_CLAIMFORM_START,
  }
}

export const getClaimFormSuccess =(payload) => {
  return {
    type: GET_CLAIMFORM_SUCCESS,
   payload,
  }
}

export const getClaimFormFailure = error => {
  return {
    type: GET_CLAIMFORM_FAILURE,
    payload:error,
  }
}
export const getClaimFormReset = () => {
  return {
    type: GET_CLAIMFORM_RESET,
  }
}



export const updateClaimFormStart = payload => {
  return {
    type: UPDATE_CLAIMFORM_START,
    payload,
  }
}

export const updateClaimFormSuccess = payload => {
  return {
    type: UPDATE_CLAIMFORM_SUCCESS,
    payload,
  }
}

export const updateClaimFormFailure = error => {
  return {
    type: UPDATE_CLAIMFORM_FAILURE,
    error,
  }
}
export const updateClaimFormReset = () => {
  return {
    type: UPDATE_CLAIMFORM_RESET,
  }
}



export const sortClaimStart = (payload) => ({
  type: SORT_CLAIMFORM_START,
  payload,
})

export const sortClaimSuccess = payload => ({
  type: SORT_CLAIMFORM_SUCCESS,
  payload,
})

export const sortClaimFailure = error => ({
  type: SORT_CLAIMFORM_FAILURE,
  payload: error,
})
export const sortClaimReset = () => ({
  type: SORT_CLAIMFORM_RESET,
})

export const viewClaimFormStart = (payload) => ({
  type: VIEW_CLAIMFORM_START,
  payload,
})

export const viewClaimFormSuccess = payload => {
  return {
    type: VIEW_CLAIMFORM_SUCCESS,
    payload,
  }
}

export const viewClaimFormFailure = error => {
  return {
    type: VIEW_CLAIMFORM_FAILURE,
    error,
  }
}
export const viewClaimFormReset = () => {
  return {
    type: VIEW_CLAIMFORM_RESET,
  }
}
export const createClaimLink = payload =>({
  type: CREATE_CLAIM_LINK,
  payload
})

export const createClaimLinkSuccess = payload =>({
  type: CREATE_CLAIM_LINK_SUCCESS,
  payload
})

export const createClaimLinkFailed = payload =>({
  type: CREATE_CLAIM_LINK_FAILED,
  payload
})

export const viewClaimLink = payload =>({
  type: VIEW_CLAIM_LINK,
  payload
})

export const viewClaimLinkSuccess = payload =>({
  type: VIEW_CLAIM_LINK_SUCCESS,
  payload
})

export const viewClaimLinkFailed = payload =>({
  type: VIEW_CLAIM_LINK_FAILED,
  payload
})


export const submitClaimLink = payload =>({
  type: SUBMIT_CLAIM_LINK,
  payload
})

export const submitClaimLinkSuccess = payload =>({
  type: SUBMIT_CLAIM_LINK_SUCCESS,
  payload
})

export const submitClaimLinkFailed = payload =>({
  type: SUBMIT_CLAIM_LINK_FAILED,
  payload
})

export const customerPolicyClaim = (payload) =>({
  type: CUSTOMER_POLICY_CLAIM,
  payload
})

export const customerPolicyClaimSuccess = (payload) =>({
  type: CUSTOMER_POLICY_CLAIM_SUCCESS,
  payload
})

export const customerPolicyClaimFailed = (payload) => ({
  type: CUSTOMER_POLICY_CLAIM_FAILED,
  payload
});

export const customerPolicyLOB = (payload) => ({
  type: CUSTOMER_POLICY_LOB,
  payload
});

export const customerPolicyLOBSuccess = (payload) =>({
  type: CUSTOMER_POLICY_LOB_SUCCESS,
  payload
})

export const customerPolicyLOBFailed = (payload) =>({
  type: CUSTOMER_POLICY_LOB_FAILED,
  payload
})